<template>
  <SpinnerComp v-if="loading" />
  <div
    v-else
    class="max-w-3xl mx-auto p-6 bg-white shadow-black shadow-md rounded-lg mt-8 mb-8"
  >
    <h2 class="text-2xl font-semibold text-blue-600 mb-6">
      Datos de la Empresa
    </h2>
    <form @submit.prevent="actualizarDatos" class="space-y-6">
      <div>
        <label for="nombre" class="block text-gray-700 font-medium"
          >Nombre:
        </label>
        <input
          id="nombre"
          type="text"
          v-model="empresa.nombre"
          class="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label for="rfc" class="block text-gray-700 font-medium">RFC:</label>
        <input
          id="rfc"
          type="text"
          v-model="empresa.rfc"
          class="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label for="telefono" class="block text-gray-700 font-medium"
          >Teléfono:</label
        >
        <input
          id="telefono"
          type="tel"
          v-model="empresa.telefono"
          class="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label for="correo" class="block text-gray-700 font-medium"
          >Correo Electrónico:</label
        >
        <input
          id="correo"
          type="email"
          v-model="empresa.correo"
          class="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label for="calle" class="block text-gray-700 font-medium"
          >Calle y Número:</label
        >
        <input
          id="calle"
          type="text"
          v-model="empresa.calle"
          class="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label for="colonia" class="block text-gray-700 font-medium"
          >Colonia:</label
        >
        <input
          id="colonia"
          type="text"
          v-model="empresa.colonia"
          class="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label for="municipio" class="block text-gray-700 font-medium"
          >Municipio y Código Postal:</label
        >
        <input
          id="municipio"
          type="text"
          v-model="empresa.municipio"
          class="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <button
        type="submit"
        class="w-full py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        Modificar Datos
      </button>
    </form>

  </div>
</template>

<script>
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  data() {
    return {
      empresa: {},
      loading: false,
    };
  },
  components: { SpinnerComp },
  methods: {
    getData() {
      this.loading = true;
      this.$axios
        .get("/getCon")
        .then((response) => {
          // Asignar el primer elemento del array al objeto empresa
          if (response.data.length > 0) {
            this.empresa = response.data[0];
          } else {
            console.error("El array recibido está vacío.");
          }
        })
        .catch((error) => {
          console.error("Error al realizar la solicitud:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    actualizarDatos() {
      this.$axios
        .put(`/updateCon/1`, this.empresa)
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error al actualizar los datos:", error);
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
